import { httpRequest } from 'chipta-libs/utils/http.js';
import inIframe from 'chipta-libs/utils/in-iframe.js';

export function apiGet(path, headers={}) {
  return apiRequest('GET', path, headers);
}

export function apiPost(path, data=null, headers={}) {
  return apiRequest('POST', path, headers, data);
}

export function apiPut(path, data=null, headers={}) {
  return apiRequest('PUT', path, headers, data);
}

export function apiPatch(path, data=null, headers={}) {
  return apiRequest('PATCH', path, headers, data);
}

function apiRequest(method, path, headers={}, data=null) {
  return new Promise((success, reject) => {
    httpRequest(
      method,
      addQueryParams('/rest/' + path),
      getApiHeaders(headers),
      data
    ).then(request => {
      success(getResponseData(request));
    }).catch(request => {
      reject(getResponseData(request));
    });
  });
}

function getResponseData(request) {
  return {
    status: request.status,
    data: parseResponseJson(request)
  }
}

function parseResponseJson(request) {
  try {
    return JSON.parse(request.responseText);
  } catch (e) {
    console.debug("Response data is not valid JSON", request.responseText);
    return {}
  }
}

function addQueryParams(path) {
  if (inIframe()) {
    if (path.indexOf('?') === -1) {
      return path + '?iframe=1';
    } else {
      return path + '&iframe=1'
    }
  } else {
    return path;
  }
}

function getApiHeaders(headers) {

  const newHeaders = Object.assign(
    {
      'Accept-Language': jsVar('language')
    },
    headers
  );

  if (jsVar('authUserToken')) {
    newHeaders['X-API-Token'] = jsVar('authUserToken');
  }

  return newHeaders;

}
